import { gql } from '@apollo/client'

export default gql`
  mutation addToCart($cartInfo: CartInfo!) {
    addToCart(cartInfo: $cartInfo) {
      cart_id
    }
  }
`
